module.exports = __webpack_public_path__ + "img/paymi-logo-color-new.703a1ba4.png";